import React from 'react';
import Button from './Button'; 
import '../styles/PopupAsk.css';

const PopupAsk = ({ state }) => {
  return (
    <>
        <div className="popup-ask-back"></div>
        <div className="popup-ask-overlay">
            <div className="popup-ask-question-text">{state.question}</div>
            <div className="popup-ask-buttons">
                <Button type={state.leftType} onClick={state.leftAction}>{state.leftText}</Button>
                <Button type={state.rightType} onClick={state.rightAction}>{state.rightText}</Button>
            </div>
        </div>
    </>
  );
};

export default PopupAsk;